import React from "react";
import ajax from "./../lib/ajax.js";
import PaystubSearchPanel from './paystub/paystub-search.jsx';
import PaystubGrid from './paystub/paystub-grid.jsx';
import PaystubGridMobile from './paystub/paystub-grid-mobile.jsx';
import moment from 'moment';
import context from "./../lib/context.js";

export default class PeoplePaystub extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showGrid: false,
            paystubList: [],
            pageSize: 10,
            gridStartIndex: 0,
            gridEndIndex: 10,
            currentIndex: 0,
            docUrl: ''
        };
        this.onSearchClick = this.onSearchClick.bind(this);
        this.onPaystubDetailClick = this.onPaystubDetailClick.bind(this);
        this.onNavigate = this.onNavigate.bind(this);
        this.isAndroid = this.isAndroid.bind(this);
        this.isIos = this.isIos.bind(this);
    }
    onSearchClick(searchParams) {
        let self = this;
        let fromDate = moment().year(searchParams.year).month(searchParams.fromDate - 1).date(1).format('MM-DD-YYYY');
        let lastDate = new Date(searchParams.year,searchParams.toDate,0).getDate();
        let newDate = new Date();
        newDate = newDate.setFullYear(searchParams.year,searchParams.toDate - 1,lastDate);
        let toDate = moment(newDate).format('MM-DD-YYYY');   
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });
        ajax.api()
            .get(`people/get-paystub/${fromDate}/${toDate}`)
            .then(function (res) {
                const result = res.data;
                context.message({
                    show: false,
                });
                self.setState({
                    showGrid: true,
                    paystubList: result,
                    currentIndex: 0,
                    gridStartIndex: 0,
                    gridEndIndex: 10
                });
            })
            .catch(function (e) {
                console.log(e);
                let data = e.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.message,
                    buttons: "close"
                });
            });

    }
    onPaystubDetailClick(id) {
        let self = this;
        let isMobile = this.isAndroid() || this.isIos();
        let url = context.routeUrl(`api/get-paystub-detail/` + id);
        if (!isMobile) {
            window.open(url, "_blank");
        } else {
            self.setState({
                docUrl: url
            });
            setTimeout(function () {
                document.getElementById('mobile-link').click();
            }, 10);
        }

    }
    onNavigate(index) {
        index = index + 1;
        let self = this;
        let pageSize = this.state.pageSize;
        let gridEndIndex = index * pageSize;
        let gridStartIndex = index * pageSize - pageSize;
        self.setState({
            gridStartIndex: gridStartIndex,
            gridEndIndex: gridEndIndex,
            currentIndex: index - 1,
        });

    }
    isAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;
    }

    isIos() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('ipad') > - 1 || ua.indexOf('iphone') > -1;
    }

    render() {
        const self = this;
        let mobile = this.isIos() || this.isAndroid();
        return (
            <div className="container">
                <a id="mobile-link" className="ap-hidden" href={this.state.docUrl} />
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-center ap-title">Pay Statements</h2>
                        <h3 className="text-center ap-sub-title">View Pay Statements</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <PaystubSearchPanel onSearchClick={this.onSearchClick} />
                    </div>
                </div>
                <hr />
                <div className={this.state.showGrid? "row": "ap-hidden"}>
                    <div className="col-md-12">
                        {mobile ? <PaystubGridMobile paystubs={this.state.paystubList} onPaystubDetailClick={this.onPaystubDetailClick}
                            onNavigate={this.onNavigate} startIndex={this.state.gridStartIndex} endIndex={this.state.gridEndIndex} currentIndex={this.state.currentIndex} /> :
                            <PaystubGrid paystubs={this.state.paystubList} onPaystubDetailClick={this.onPaystubDetailClick}
                                onNavigate={this.onNavigate} startIndex={this.state.gridStartIndex} endIndex={this.state.gridEndIndex} currentIndex={this.state.currentIndex} />
                        }
                    </div>
                </div>
            </div>
        );
    }

}